/**
 * A Google Maps search link for a place: what the event page's "Get
 * directions" opens and what the CSV exports carry. `placeId` pins the result
 * to the exact Google place when the event has one.
 */
export const googleMapsLink = (query: string, placeId?: string | null) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}${
    placeId ? `&query_place_id=${encodeURIComponent(placeId)}` : ""
  }`;
